<template>

	<div class="main-contents">
		<div class="package">
			<div class="table">
				<div class="list-box">
					<div class="tit">내 IT프로 &gt; 참여 프로젝트</div>
					<div class="search-box interval">
						<div class="box-line">
								<SelectComp type="select" list="2:참여예정,1:참여중,9:참여완료,99:중도철수" :isAll="true" title="참여 상태" v-model="input.projectRecrStatus"/>
								
								<SelectComp type="select" list="05:기술사,04:특급,03:고급,02:중급,01:초급" :isAll="true" title="투입등급" v-model="input.projectJoinTechGradeCd"/>

								<SelectComp type="select" list="1:프로젝트명,2:IT프로명" v-model="input.searchGubun"/>						

								<InputComp type="text" classNm="search_box int" :placeholder="input.searchGubun == '1' ? '프로젝트명' : 'IT프로명'" v-model="input.searchKeyword" @keyup.enter="getList('1')" />
								
							<div class="search_btn" @click="getList('1')">
								<img class="search" src="/images/icon_srch.png" alt="검색버튼"/>
							</div>
						</div>
					</div>
					<div class="filter">
						<div class="filter_box">
							<ul>
								<li><img :class="input.orderGubun == '1' ? 'filter' : ''" src="/images/icon_filter.png" alt="필터"/><p @click="orderSearch('1')">등록일 순</p><span>ㅣ</span></li>
								<li><img :class="input.orderGubun == '2' ? 'filter' : ''" src="/images/icon_filter.png" alt="필터"/><p @click="orderSearch('2')">참여율 높은 순</p><span>ㅣ</span></li>
								<li><img :class="input.orderGubun == '3' ? 'filter' : ''" src="/images/icon_filter.png" alt="필터"/><p @click="orderSearch('3')">참여율 낮은 순</p></li>
							</ul>
						</div>
					</div>
					<!-- 전체프로젝트 리스트 -->
					<div class="Board type3">
						<!-- 현황 다운로드 버튼 -->
						<div class="humaninfo-box dco2">
							<div class="btn-humaninfo particiStatus2" @click="statusDown()">
								<img src="/images/status_down_btn.png">
								<p>참여현황 다운로드</p>
							</div>
						</div>
						<table class="Board_type3 demand sco">
							<colgroup>
								<col width="5%">
								<col width="48%">
								<col width="15%">
								<col width="6%">
								<col width="10%">
								<col width="6%">
								<col width="10%">
							</colgroup>
							<thead>
								<tr>
									<th>NO</th>
									<th>프로젝트명</th>
									<th>참여기간</th>
									<th>투입등급</th>
									<th>참여상태</th>
									<th>프로젝트<br />참여율</th>
									<th>IT프로명</th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="(project, index) in tecMberList" :key="index">
									<td class="score">{{ (pageInfo.pageIndex - 1) * pageInfo.pageUnit + (index + 1)}}</td>
									<td class="project">
										<p style="width: 390px;">{{project.projectNm}}</p><div class="btn dt" @click="clickProjectInfo(project.projectSeq, project.projectRecrStatus)">자세히보기 &#9654;</div>
									</td>
									<td class="score">{{project.projectRecrStartEndYyyymmdd}}</td>
									<td class="score"><grade-img type="LICENSE_TECH_ADM" :grade="project.projectJoinTechGradeCd"/></td>
									<td class="score">
										<span v-if="project.projectRecrStatus == '1'"><div class="light"></div>참 여 중<nbsp n="2" /></span>
										<span v-else-if="project.projectRecrStatus == '2'"><div class="light yw"></div>참여예정</span>
										<span v-else-if="project.projectRecrStatus == '9'"><div class="light dg"></div>참여완료</span>
										<span v-else-if="project.projectRecrStatus == '99'"><div class="light rd"></div>중도철수</span>
									</td>
									<td class="score">
										<!-- <img :src="'/images/' + (project.exeRecrPer == undefined || project.exeRecrPer == '' ? '0' : project.exeRecrPer) + '_percent.png'" alt="참여율"/> -->
										{{ project.exeRecrPer == undefined || project.exeRecrPer == '' ? '0%' : project.exeRecrPer + '%' }}
									</td>
									<td v-if="project.mberInfoYn == 'Y'" class="score btn_cursor" @click="openPop(project.mberSeq)">{{project.mberNm}} &#9654;</td>
									<td v-else class="score">{{project.mberNm}}</td>
								</tr>

								<!-- 프로젝트가 없을 경우 -->
								<tr v-if="pageInfo.totalRecordCount == 0">
									<td colspan="7" class="none">IT프로가 없습니다.</td>
								</tr>

							</tbody>
						</table>
					</div>
					
					<!--페이징 컴포넌트 -->
					<PagingComp :pageInfo="pageInfo" @page-click="goPage"/>

				</div>
			</div>
		</div>
	</div>

</template>

<script>

import PagingComp from '@/components/PagingComp.vue';
import gradeImg from "@/components/highpro/GradeImg.vue";

export default {
	
	components : {
		PagingComp ,
		gradeImg ,
	},

	data() {
		return {
			input: {
				pageIndex : '1',
				orderGubun : '1',		// 1:등록일 순, 2:참여율 높은순, 3:참여율 낮은순
				searchGubun : '1',		// 1:프로젝트명, 2:IT프로명
				projectRecrStatus : this.$route.params.projectRecrStatus || '',	// 프로젝트상태 (참여상태) 1:참여중, 2:참여예정, 9:완료
				projectJoinTechGradeCd : '', // 프로젝트 투입등급  01:초급, 02:중급, 03:고급, 04:특급, 05:기술사
				searchKeyword : '',
			}, // 검색조건		
			
			tecMberList : [],
			pageInfo : {},
		};
	},
	bforeCreate() {
		// console.log('beforeCreate');
	},
	created() {
		// console.log('created');
	},
	beforeMount() {
		// console.log('beforeMount');
	},
	mounted() {
		// console.log('mounted');

		if(this.$route.params != undefined && this.$route.params.projectRecrStatus != undefined) {
			this.input.projectRecrStatus = this.$route.params.projectRecrStatus;
		}

		this.getList();
	},
	beforeUpdate() {
		// console.log('beforeUpdate');
	},
	updated() {
		// console.log('update');
	},
	beforeDestroy() {
		// console.log('beforeDestroy');
	},
	destroyed() {
		// console.log('destroyed');
	},

	methods: {
		getList(div, isScroll = false) {

			if(div) this.input.pageIndex = 1;
			this.$.httpPost('/api/prj/modul/getTecProjectJoinStatusList', this.input)
				.then(res => {
					// console.log(res.data);
					this.tecMberList	= res.data.tecMberList;
					this.pageInfo		= res.data.pageInfo;

					if(isScroll) {
						window.scroll(0, 0);
					}
				})
				.catch(err => {
					alert(err.response.data.error_description);
				});
		},

		goPage(page) {
			// console.log(page);
			this.input.pageIndex = page;
			this.getList('', true);
		},

		orderSearch(orderGubun) {
			this.input.orderGubun = orderGubun;
			this.input.pageIndex = 1;
			this.getList();
		},
		
		clickProjectInfo(projectSeq, projectRecrStatus) {
			var param = {
				projectSeq : projectSeq,
				projectRecrStatus : projectRecrStatus
			};
			this.$.popup('/sco/prj/PRJ401P01', param, {width:0, height:0})
				// .then(res => {})
				// .catch(err => {})
				;
		},
		
		openPop(seq) {
			var div = 'tec';
			this.$.popup('/dco/pmg/myp/MYP301P01', { seq, div }); 
		},
		
		statusDown(){
			var param = {
				mberList : this.tecMberList
			}
			this.$.fileDownload ('/api/prj/getPrjJoinMberFileDown', param)
			.then(() => {
					// console.log("res : " + res);
				})
				.catch(err => {
					// console.log('============================='); 
					// console.log(err);
					// console.log(err.response);
					// console.log('============================='); 

					alert(err.response.data.error_description);
				});
		} 
		
	},
};
</script>
